import React from 'react';
import { motion } from 'framer-motion';
export type AvatarState = 'idle' | 'listening' | 'speaking' | 'emphasis';
interface AvatarControlsProps {
  currentState: AvatarState;
  onStateChange: (state: AvatarState) => void;
}
export function AvatarControls({
  currentState,
  onStateChange
}: AvatarControlsProps) {
  const states: AvatarState[] = ['idle', 'listening', 'speaking', 'emphasis'];
  return <div className="flex flex-col items-center space-y-8 z-10 relative" data-id="element-9">
      <div className="flex items-center space-x-8 md:space-x-12" data-id="element-10">
        {states.map(state => <button key={state} onClick={() => onStateChange(state)} className="group relative flex flex-col items-center focus:outline-none" aria-label={`Switch to ${state} mode`} data-id="element-11">
            <span className={`text-xs tracking-[0.2em] uppercase transition-colors duration-500 font-medium ${currentState === state ? 'text-[#E87722]' : 'text-slate-500 group-hover:text-slate-300'}`} data-id="element-12">
              {state}
            </span>
            {currentState === state && <motion.div layoutId="activeIndicator" className="absolute -bottom-3 w-1.5 h-1.5 rounded-full" style={{
          backgroundColor: '#E87722',
          boxShadow: '0 0 10px rgba(232, 119, 34, 0.7)'
        }} transition={{
          type: 'spring',
          stiffness: 500,
          damping: 30
        }} data-id="element-13" />}
          </button>)}
      </div>

      <div className="opacity-40 pt-4" data-id="element-14">
        <span className="text-[10px] tracking-[0.4em] text-slate-400 font-light uppercase" data-id="element-15">
          Brookfield AI
        </span>
      </div>
    </div>;
}